import { storageEventCopy } from './storageEventCopy';

/**
 * User-facing strings for `getStorageStatus` (worker storage object indicators).
 */
export const storageStatusCopy = {
  notRegistered: 'Not registered',
  lost: 'Lost',
  noHistory: 'No history',
  pickedUpFromCustomer: storageEventCopy.pickedUpFromCustomer.title,
  pickedUpFromSupplier: 'Picked up from supplier',
  deliveredToCustomer: storageEventCopy.deliveredToCustomer.title,
  mountedOnCar: storageEventCopy.mountedOnCar.title,
  pickedUpByCustomer: storageEventCopy.pickedUpByCustomer.title,
  withCustomer: 'With customer',
  notReceived: 'Not received',
  discarded: 'Discarded',
  beingWorkedOn: 'Being worked on',
  atFacility: 'At facility',
  loadedOnVehicle: 'Loaded on vehicle',
  inTransit: 'In transit',
  inTransitUnknownOrigin: 'In transit · origin unknown',
  atLoadingDock: 'At loading dock',
  inStorage: 'In storage',
  unknownStatus: 'Unknown status',
  fromStorageUnit: (brief: string) => `From ${brief}`,
  toStorageUnit: (brief: string) => `to ${brief}`,
  vehicleLabel: (name: string) => `Vehicle ${name}`
} as const;
